/**
 * GYIK section -- accordion + load more (kategorizálás nincs).
 */
(function () {
  'use strict';

  var sections = document.querySelectorAll('.gyik');
  if (!sections.length) return;

  sections.forEach(function (section) {
    var list      = section.querySelector('.gyik__list');
    var items     = list ? Array.prototype.slice.call(list.querySelectorAll('.gyik__item')) : [];
    var moreWrap  = section.querySelector('.gyik__more');
    var moreBtn   = section.querySelector('.gyik__more-btn');
    var baseLimit = parseInt(section.getAttribute('data-limit'), 10) || 5;

    /* ---- Accordion toggle ---- */
    items.forEach(function (item) {
      var btn   = item.querySelector('.gyik__question');
      var panel = item.querySelector('.gyik__answer');
      if (!btn || !panel) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';

        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          panel.offsetHeight; // reflow
          panel.style.height = '0';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
          var onEnd = function () {
            panel.removeEventListener('transitionend', onEnd);
            if (btn.getAttribute('aria-expanded') === 'true') {
              panel.style.height = 'auto';
            }
          };
          panel.addEventListener('transitionend', onEnd);
        }
      });
    });

    /* ---- Kezdeti láthatóság (limit) + Load more ---- */
    function applyVisibility() {
      items.forEach(function (item, idx) {
        item.style.display = idx < baseLimit ? '' : 'none';
      });
      if (moreWrap) {
        moreWrap.style.display = items.length > baseLimit ? '' : 'none';
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var hidden = items.filter(function (item) {
          return item.style.display === 'none';
        });

        hidden.slice(0, baseLimit).forEach(function (item) {
          item.style.display = '';
        });

        var remaining = hidden.length - Math.min(hidden.length, baseLimit);
        if (moreWrap) {
          moreWrap.style.display = remaining > 0 ? '' : 'none';
        }
      });
    }

    applyVisibility();
  });
})();
